import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import type { FlightMachineContext } from "../../types";

export const AirPriceDropGuards = {
  hasPriceDropIdAndEnabled: (ctx: FlightMachineContext, _event: unknown) => {
    return (
      !!ctx[ParentState.priceDrop]?.candidateId &&
      ctx.featureFlags?.enablePriceDropProtection
    );
  },
};

export const AirPriceDropGuardTypes = getObjectKeysAsObject(AirPriceDropGuards);
